/**
 * @name Summary Definitions API Endpoints
 * @description Endpoints for firm and fund summary definition CRUD operations
 */

import API from '../config';

const base = `${API.BASE_DEV_HOST}/api`;

// Global summary definitions (admin only for writes)
export const globalDefinitions = `${base}/summary-definitions/global`;
export const globalDefinitionById = (id: number) => `${base}/summary-definitions/global/${id}`;

// Firm summary definitions
export const firmDefinitions = (firmId: number) => `${base}/firms/${firmId}/summary-definitions`;
export const firmDefinitionById = (firmId: number, definitionId: number) =>
  `${base}/firms/${firmId}/summary-definitions/${definitionId}`;
export const firmDefinitionsOrder = (firmId: number) => `${base}/firms/${firmId}/summary-definitions/order`;

// Firm summary definition chart data (trending across measurement dates)
export const firmDefinitionChartData = (firmId: number, definitionId: number) =>
  `${base}/firms/${firmId}/summary-definitions/${definitionId}/chart-data`;

// Fund summary definitions
export const fundDefinitions = (fundId: number) => `${base}/funds/${fundId}/summary-definitions`;
export const fundDefinitionById = (fundId: number, definitionId: number) =>
  `${base}/funds/${fundId}/summary-definitions/${definitionId}`;
export const fundDefinitionsOrder = (fundId: number) => `${base}/funds/${fundId}/summary-definitions/order`;
